"use client";

import { useEffect } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { captureException } from "@/lib/monitoring";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error, { digest: error.digest, boundary: "app/error" });
  }, [error]);

  return (
    <div className="flex h-full min-h-[60vh] flex-col items-center justify-center bg-bg px-4">
      <div className="flex max-w-[420px] flex-col items-center text-center">
        <span className="caps-mute mb-3">Something went wrong</span>
        <h1 className="text-2xl font-bold text-fg">An unexpected error occurred</h1>
        <p className="mt-3 text-sm text-fg-dim">
          The error has been logged. You can try again, or head back to your ranges.
        </p>
        {error.digest ? (
          <p className="mt-2 font-mono text-xs text-fg-mute">ref: {error.digest}</p>
        ) : null}
        <div className="mt-6 flex gap-3">
          <Button onClick={reset}>Try again</Button>
          <Button variant="ghost" asChild>
            <Link href="/ranges">Back to ranges</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
